/* Dulceria Wunschbox Builder */
(function () {
  'use strict';
  const SIZE_LAYOUT = { 4: 4, 8: 8, 16: 16 };
  function formatEUR(n) { return '€ ' + (Number.isInteger(n) ? n : n.toFixed(2).replace('.', ',')); }

  function init(root) {
    if (!root || root.dataset.wbInitialized) return;
    root.dataset.wbInitialized = '1';

    function attr(name) { return root.getAttribute(name) || ''; }

    const cfg = {
      defaultSize: parseInt(attr('data-default-size'), 10) || 8,
      variants: {
        4:  attr('data-variant-4er'),
        8:  attr('data-variant-8er'),
        16: attr('data-variant-16er')
      },
      prices: {
        4:  parseFloat(attr('data-price-4er')  || '13'),
        8:  parseFloat(attr('data-price-8er')  || '24'),
        16: parseFloat(attr('data-price-16er') || '40')
      }
    };

    const state = { size: cfg.defaultSize, menge: 1, fills: [] };

    const $pills      = root.querySelectorAll('.wb-size-pill');
    const $cards      = root.querySelectorAll('.wb-praline-card');
    const $slotGrid   = root.querySelector('[data-slot-grid]');
    const $sizeLabel  = root.querySelector('[data-size-label]');
    const $ctrFilled  = root.querySelector('[data-counter-filled]');
    const $ctrTotal   = root.querySelector('[data-counter-total]');
    const $ctrRem     = root.querySelector('[data-counter-remaining]');
    const $statFilled = root.querySelector('[data-stat-filled]');
    const $statTotal  = root.querySelector('[data-stat-total]');
    const $statRem    = root.querySelector('[data-stat-remaining]');
    const $progFill   = root.querySelector('[data-progress-fill]');
    const $cta        = root.querySelector('[data-cta]');
    const $ctaPrice   = root.querySelector('[data-cta-price]');
    const $ctaBox     = root.querySelector('[data-cta-box]');
    const $hint       = root.querySelector('[data-hint]');
    const $mengeCount = root.querySelector('[data-menge-count]');
    const $mengeDec   = root.querySelector('[data-menge="dec"]');
    const $mengeInc   = root.querySelector('[data-menge="inc"]');
    const $multibox   = root.querySelector('[data-multibox]');

    function renderSlots(dropIdx) {
      $slotGrid.dataset.size = state.size;
      $slotGrid.innerHTML = '';
      for (let i = 0; i < state.size; i++) {
        const slot = document.createElement('div');
        slot.className = 'wb-preview-slot';
        slot.dataset.index = i;
        const fill = state.fills[i];
        if (fill) {
          slot.classList.add('filled');
          slot.setAttribute('aria-label', fill.name + ' — Klicken zum Entfernen');
          const inner = document.createElement('div');
          inner.className = 'wb-fill ' + fill.color;
          if (i !== dropIdx) inner.style.animation = 'none';
          slot.appendChild(inner);
        } else {
          slot.classList.add('empty');
        }
        $slotGrid.appendChild(slot);
      }
    }

    function renderStats() {
      const filled = state.fills.length;
      const rem = Math.max(0, state.size - filled);
      $ctrFilled.textContent = filled;
      $ctrTotal.textContent = state.size;
      $ctrRem.textContent = rem;
      $statFilled.textContent = filled;
      $statTotal.textContent = state.size;
      $statRem.textContent = rem;
      $progFill.style.width = (state.size ? (filled / state.size) * 100 : 0) + '%';
    }

    function renderSize() {
      $sizeLabel.textContent = state.size + 'er BOX';
      if ($ctaBox) $ctaBox.textContent = state.size + 'er Box';
      $pills.forEach(p => p.setAttribute('aria-checked', String(parseInt(p.dataset.size, 10) === state.size)));
    }

    function renderCTA() {
      const filled = state.fills.length;
      const isFull = filled === state.size;
      const total = cfg.prices[state.size] * state.menge;
      $ctaPrice.textContent = formatEUR(total);
      $cta.classList.toggle('ready', isFull);
      $cta.setAttribute('aria-disabled', String(!isFull));
      if (isFull) {
        $hint.textContent = state.menge > 1
          ? state.menge + ' × ' + state.size + 'er Boxen bereit.'
          : 'Deine ' + state.size + 'er Wunschbox ist bereit.';
      } else {
        const r = state.size - filled;
        $hint.textContent = r === 1
          ? 'Wähle noch 1 Praline aus.'
          : 'Wähle noch ' + r + ' Pralinen aus.';
      }
    }

    function renderCards() {
      const counts = new Map();
      for (const f of state.fills) counts.set(f.id, (counts.get(f.id) || 0) + 1);
      const boxFull = state.fills.length >= state.size;
      $cards.forEach(card => {
        const id = card.dataset.pralineId;
        const c = counts.get(id) || 0;
        const $badge = card.querySelector('[data-qty-badge]');
        const $badgeN = card.querySelector('[data-qty-badge-n]');
        const $controls = card.querySelector('[data-controls]');
        const $dec = card.querySelector('[data-action="dec"]');
        const $inc = card.querySelector('[data-action="inc"]');
        if (c > 0) {
          card.dataset.selected = 'true';
          $badge.hidden = false;
          $badgeN.textContent = c;
          $controls.hidden = false;
          $dec.disabled = false;
          $inc.disabled = boxFull;
        } else {
          card.dataset.selected = 'false';
          $badge.hidden = true;
          $controls.hidden = true;
        }
      });
    }

    function renderMenge() {
      $mengeCount.textContent = state.menge;
      $mengeDec.disabled = state.menge <= 1;
    }

    function renderAll(dropIdx) {
      renderSlots(dropIdx);
      renderStats();
      renderSize();
      renderCTA();
      renderCards();
      renderMenge();
    }

    function setSize(newSize) {
      newSize = parseInt(newSize, 10);
      if (!SIZE_LAYOUT[newSize]) return;
      while (state.fills.length > newSize) state.fills.pop();
      state.size = newSize;
      renderAll();
    }

    function addPraline(card) {
      if (state.fills.length >= state.size) return;
      state.fills.push({
        id: card.dataset.pralineId,
        name: card.dataset.pralineName,
        color: card.dataset.pralineColor,
        limited: card.dataset.pralineLimited === 'true'
      });
      renderAll(state.fills.length - 1);
    }

    function decPraline(card) {
      const id = card.dataset.pralineId;
      for (let i = state.fills.length - 1; i >= 0; i--) {
        if (state.fills[i].id === id) { state.fills.splice(i, 1); break; }
      }
      renderAll();
    }

    function removeSlot(index) {
      if (index < 0 || index >= state.fills.length) return;
      state.fills.splice(index, 1);
      renderAll();
    }

    function setMenge(delta) {
      const next = state.menge + delta;
      if (next < 1 || next > 20) return;
      state.menge = next;
      renderMenge();
      renderCTA();
    }

    function buildProperties() {
      const grouped = new Map();
      for (const f of state.fills) {
        const key = f.limited ? f.name + ' (LIMITIERT)' : f.name;
        grouped.set(key, (grouped.get(key) || 0) + 1);
      }
      const keys = Array.from(grouped.keys()).sort((a, b) => a.localeCompare(b, 'de'));
      const props = {};
      for (const k of keys) props[k] = '× ' + grouped.get(k);
      props['_box_size'] = state.size + 'er';
      return props;
    }

    function addToCart(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (state.fills.length !== state.size) {
        $hint.textContent = 'Bitte zuerst alle ' + state.size + ' Plätze füllen.';
        return false;
      }
      var raw = String(cfg.variants[state.size] || '').replace(/[^0-9]/g, '');
      var variantId = parseInt(raw, 10);
      if (!variantId) {
        $hint.textContent = 'Fehler: keine Variante hinterlegt.';
        console.error('[wunschbox] no variant id for size', state.size, cfg.variants);
        return false;
      }
      $cta.style.pointerEvents = 'none';
      $hint.textContent = 'Wird hinzugefügt …';

      var payload = { items: [{ id: variantId, quantity: state.menge, properties: buildProperties() }] };
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        return res.text().then(function (txt) {
          var data = null;
          try { data = JSON.parse(txt); } catch (err) {}
          if (!res.ok) {
            var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status);
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function () {
        state.fills = [];
        state.menge = 1;
        renderAll();
        $hint.textContent = 'In den Warenkorb gelegt.';
        if ($multibox) $multibox.classList.add('visible');

        document.dispatchEvent(new CustomEvent('dulceria:drawer:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));

        var drawer = document.querySelector('[data-dulceria-drawer]');
        setTimeout(function () {
          var open = drawer && drawer.classList.contains('is-open');
          if (!open) { window.location.href = rootUrl + 'cart'; }
        }, 450);
      })
      .catch(function (err) {
        console.error('[wunschbox] cart add failed:', err);
        $hint.textContent = 'Fehler: ' + (err && err.message ? err.message : 'Warenkorb nicht erreichbar');
      })
      .finally(function () {
        $cta.style.pointerEvents = '';
      });

      return false;
    }

    $pills.forEach(p => p.addEventListener('click', () => setSize(p.dataset.size)));
    $cards.forEach(card => {
      card.addEventListener('click', e => {
        if (e.target.closest('[data-controls]')) return;
        addPraline(card);
      });
      const $dec = card.querySelector('[data-action="dec"]');
      const $inc = card.querySelector('[data-action="inc"]');
      $dec && $dec.addEventListener('click', e => { e.stopPropagation(); decPraline(card); });
      $inc && $inc.addEventListener('click', e => { e.stopPropagation(); addPraline(card); });
    });
    $slotGrid.addEventListener('click', e => {
      const slot = e.target.closest('.wb-preview-slot.filled');
      if (!slot) return;
      removeSlot(parseInt(slot.dataset.index, 10));
    });
    $mengeInc && $mengeInc.addEventListener('click', () => setMenge(+1));
    $mengeDec && $mengeDec.addEventListener('click', () => setMenge(-1));

    $cta.addEventListener('click', addToCart);
    $cta.setAttribute('role', 'button');

    $multibox && $multibox.addEventListener('click', () => {
      $multibox.classList.remove('visible');
      root.querySelector('.wb-praline-grid').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    setSize(cfg.defaultSize);
    console.log('[wunschbox] ready — variants', cfg.variants);
  }

  function boot() { document.querySelectorAll('[data-wb-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', e => {
    const sec = e.target && e.target.querySelector('[data-wb-root]');
    if (sec) init(sec);
  });
})();
